import { createSelector } from 'reselect'
import { getPageData, getPageParams } from 'selectors/page'
import { getSort, getPage, getSearch } from 'selectors/algolia2/url'

// This is the order of params from Express Router
// Example: `:category/:subject/:styles`
export const getPathParams = createSelector(
  getPageData,
  (pageData): Array<string> => {
    return pageData.pathParams || []
  }
)

export const getBrowseHitsPerPage = createSelector([getPageParams], ({ hitsPerPage }): number => {
  return Number(hitsPerPage) || 50
})

// Special Query Fields we will USE
export const getDimensionQuery = createSelector(
  [getPageParams],
  ({ width, height }): Record<string, any> => ({
    ...(width
      ? {
          width,
        }
      : {}),
    ...(height
      ? {
          height,
        }
      : {}),
  })
)

export const getPageParamsQuery = createSelector(
  [getSort, getBrowseHitsPerPage, getPage, getSearch, getDimensionQuery],
  (sort, hitsPerPage, page, query, dimensions): Record<string, any> => ({
    ...(sort !== 'default'
      ? {
          sort,
        }
      : {}),
    ...(hitsPerPage !== 50
      ? {
          hitsPerPage,
        }
      : {}),
    ...(page !== 0
      ? {
          page: page + 1,
        }
      : {}),
    ...(query
      ? {
          query,
        }
      : {
          query: '',
        }),
    ...dimensions,
  })
)
